import React, { useState } from 'react';
import Card, { CardContent } from '../../components/ui/Card';
import { SparklesIcon } from '@heroicons/react/24/outline';

interface Feature {
  id: string;
  name: string;
  description: string;
  enabled: boolean;
  category: string;
}

const AdminFeaturesPage: React.FC = () => {
  const [features] = useState<Feature[]>([
    { id: '1', name: 'Live Streaming', description: 'Enable live streaming for creators', enabled: true, category: 'content' },
    { id: '2', name: 'Shop Module', description: 'Allow creators to sell merchandise', enabled: true, category: 'monetization' },
    { id: '3', name: 'Group Chats', description: 'Enable group chat feature', enabled: false, category: 'community' },
  ]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Feature Flags</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <Card><CardContent className="p-6"><div className="flex items-center justify-between"><div><p className="text-sm text-gray-600">Total Features</p><p className="text-2xl font-bold text-gray-900">{features.length}</p></div><SparklesIcon className="w-8 h-8 text-blue-600" /></div></CardContent></Card>
        <Card><CardContent className="p-6"><div className="flex items-center justify-between"><div><p className="text-sm text-gray-600">Enabled</p><p className="text-2xl font-bold text-gray-900">{features.filter(f => f.enabled).length}</p></div><SparklesIcon className="w-8 h-8 text-green-600" /></div></CardContent></Card>
        <Card><CardContent className="p-6"><div className="flex items-center justify-between"><div><p className="text-sm text-gray-600">Disabled</p><p className="text-2xl font-bold text-gray-900">{features.filter(f => !f.enabled).length}</p></div><SparklesIcon className="w-8 h-8 text-gray-600" /></div></CardContent></Card>
      </div>

      <div className="space-y-4">
        {features.map((feature) => (
          <Card key={feature.id}><CardContent className="p-6"><div className="flex items-center justify-between"><div><h3 className="text-lg font-semibold text-gray-900">{feature.name}</h3><p className="text-sm text-gray-600">{feature.description}</p><span className="inline-block mt-2 px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800">{feature.category}</span></div><label className="relative inline-flex items-center cursor-pointer"><input type="checkbox" checked={feature.enabled} readOnly className="sr-only peer" /><div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div></label></div></CardContent></Card>
        ))}
      </div>
    </div>
  );
};

export default AdminFeaturesPage;
